/* EdgePro testimonials: prev/next arrows plus a gentle auto-advance.

   Same rail and same auto-advance rules as ep-project-cards, so the two proof
   sections on the homepage behave identically. A testimonial dwells a beat
   longer than a project card because there is more to read.

   Auto-advance rules:
   - pauses on hover, on keyboard focus inside the rail, when scrolled out of
     view, and when the tab is hidden
   - ANY deliberate interaction (arrow, swipe, wheel, keys, drag) stops it for
     good — once someone is driving, we do not fight them for the scroll
   - never starts for prefers-reduced-motion
   - loops back to the start once the end is reached */
(function () {
  if (window.__epTmNav) return;
  window.__epTmNav = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DWELL = 6000;

  function init(section) {
    var rail = section.querySelector('.ep-tm__rail');
    var nav = section.querySelector('[data-ep-tm-nav]');
    if (!rail) return;
    var prev = nav && nav.querySelector('[data-ep-tm-prev]');
    var next = nav && nav.querySelector('[data-ep-tm-next]');

    var timer = null;
    var stopped = reduced;
    var hovered = false;
    var visible = true;

    function step() {
      var item = rail.querySelector('.ep-tm__card');
      if (!item) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      return item.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return rail.scrollWidth - rail.clientWidth;
    }

    function update() {
      if (!nav) return;
      if (maxScroll() <= 4) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= maxScroll() - 4;
    }

    function advance() {
      if (maxScroll() <= 4) return;
      // At the end, wrap round to the start rather than sitting there.
      if (rail.scrollLeft >= maxScroll() - 4) {
        rail.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      }
    }

    function start() {
      if (timer || stopped || hovered || !visible || document.hidden) return;
      timer = setInterval(advance, DWELL);
    }

    function pause() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    // Hand control over permanently the moment the visitor takes it.
    function surrender() {
      stopped = true;
      pause();
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        surrender();
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        surrender();
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
      rail.addEventListener(evt, surrender, { passive: true });
    });

    section.addEventListener('mouseenter', function () {
      hovered = true;
      pause();
    });
    section.addEventListener('mouseleave', function () {
      hovered = false;
      start();
    });
    rail.addEventListener('focusin', surrender);

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) start();
          else pause();
        },
        { threshold: 0.25 }
      ).observe(section);
    }

    update();
    start();
  }

  document.querySelectorAll('.ep-tm').forEach(init);
})();
